import { Box, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useCallback } from 'react';
import { date, object } from 'yup';

import { ClaimFormValues } from 'common';
import { FormikDatePicker, FormikWizardNavButtons } from 'components/forms';
import { useWizard } from 'hooks';
import { logDev } from 'modules/utils';
import { BaseStepProps } from './ClaimFormWizard';

const dateStepVal = object().shape({
  occurrenceDate: date().required(),
});

export interface DateValues {
  occurrenceDate: Date | null;
}
export type FirestoreDateValues = Pick<ClaimFormValues, 'occurrenceDate'>;

const maxDate = new Date();

export type DateStepProps = BaseStepProps<DateValues>;

export const DateStep = ({ saveFormValues, onError, ...props }: DateStepProps) => {
  const { nextStep } = useWizard();

  const handleStepSubmit = useCallback(
    async ({ occurrenceDate }: DateValues) => {
      try {
        await saveFormValues({ occurrenceDate }); // { occurrenceDate: occurrenceDate ? Timestamp.fromDate(occurrenceDate) : null }
        await nextStep();
      } catch (err: any) {
        logDev('Error saving claim values: ', err);
        onError && onError('error saving values');
      }
    },
    [nextStep, saveFormValues, onError]
  );

  return (
    <Box>
      <Typography align='center' gutterBottom>
        What was the date when the damage occurred?
      </Typography>

      <Formik
        {...props}
        onSubmit={handleStepSubmit}
        validationSchema={dateStepVal}
        validateOnMount
        enableReinitialize
      >
        {({ handleSubmit, submitForm }) => (
          <Form onSubmit={handleSubmit}>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
              <FormikDatePicker
                name='occurrenceDate'
                label='Occurrence Date'
                minDate={undefined}
                maxDate={maxDate}
                sx={{ maxWidth: 300 }}
              />
            </Box>

            <FormikWizardNavButtons onClick={submitForm} />
          </Form>
        )}
      </Formik>
    </Box>
  );
};
